export default __webpack_public_path__ + "static/iconfont-0353f3ddfba77e5bb8de9ce7c0b8f438.woff2";